(function (Drupal, once) {
  'use strict';

  // Extend this palette here; the current color is excluded from each draw.
  const SHUFFLE_COLORS = [
    'var(--color-green)',
    'var(--color-pink)',
    'var(--color-blue)',
    'var(--color-violet)',
    'var(--color-red)',
    'var(--color-brown)',
  ];

  // Persist across AJAX reattachments; a full page load starts yellow.
  let currentColor = null;
  let nextColor = chooseNextColor();

  function chooseNextColor() {
    const candidates = SHUFFLE_COLORS.filter((color) => color !== currentColor);
    return candidates[Math.floor(Math.random() * candidates.length)];
  }

  function applyColors(button) {
    if (currentColor) {
      button.style.setProperty('--shuffle-color', currentColor);
    }
    button.style.setProperty('--shuffle-next-color', nextColor);
  }

  Drupal.behaviors.catalogShuffle = {
    attach(context) {
      const catalog = Drupal.adocsCatalog;
      if (!catalog.getForm() || !catalog.getState()) return;
      once('catalog-shuffle', document.querySelectorAll('.view-random-button')).forEach((button) => {
        button.hidden = false;
        const updateState = () => {
          const active = catalog.getState().shuffle === '1';
          button.setAttribute('aria-pressed', String(active));
          if (!active) {
            currentColor = null;
            button.style.removeProperty('--shuffle-color');
            button.classList.remove('is-color-preview');
          }
        };
        button.addEventListener('adocs:catalog-state', updateState);
        updateState();
        applyColors(button);
        button.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') {
            button.classList.add('is-color-preview');
          }
        });
        button.addEventListener('focus', () => {
          button.classList.add('is-color-preview');
        });
        ['pointerleave', 'blur'].forEach((eventName) => {
          button.addEventListener(eventName, () => {
            button.classList.remove('is-color-preview');
          });
        });

        button.addEventListener('click', (event) => {
          if (!catalog.getForm()) return;
          event.preventDefault();

          currentColor = nextColor;
          nextColor = chooseNextColor();
          applyColors(button);
          // Keep the committed color until a fresh hover/focus interaction.
          button.classList.remove('is-color-preview');

          catalog.shuffle();
        });
      });
    },
  };

})(Drupal, once);
